import { FiChevronDown, FiSettings } from 'react-icons/fi';
import { MenuItems, MenuWrapper } from 'components/Button/MenuButton';
import { useCountryParam, useMutateWatchlists } from 'utils/hooks';
import ConfirmDeleteModal from 'components/modals/ConfirmDelete';
import EditWatchlist from 'components/modals/EditWatchlist';
import IconButton from 'components/Button/IconButton';
import { Menu } from '@headlessui/react';
import PublishWatchlist from 'components/modals/PublishWatchlist';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';

function WatchlistMenu({ menuItems, ...props }) {
    const history = useHistory();
    const { remove, add } = useMutateWatchlists();
    const { mutateToWithCountryParam } = useCountryParam();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleDeleteClick = () => setShowDeleteModal(true);
    const handleCancelDelete = () => setShowDeleteModal(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const handleEditClick = () => setShowEditModal(true);
    const handleCancelEdit = () => setShowEditModal(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const handleShareClick = () => setShowShareModal(true);
    const handleCancelShare = () => setShowShareModal(false);

    const handleConfirmDelete = async () => {
        try {
            setShowDeleteModal(false);
            history.push(mutateToWithCountryParam(`/`));
            await toast.promise(
                remove({
                    id: props.watchlistId,
                    data: { name: props.watchlist.name },
                }),
                {
                    loading: 'Deleting...',
                    success: 'Watchlist deleted',
                    error: 'Could not delete watchlist',
                },
                {
                    position: 'top-right',
                },
            );
        } catch (err) {
            console.error(err);
        }
    };

    const handleConfirmEdit = async (updatedData) => {
        try {
            setShowEditModal(false);
            await toast.promise(
                add({ id: props.watchlistId, data: updatedData }),
                {
                    loading: 'Saving...',
                    success: 'Watchlist changes saved',
                    error: 'Could not save watchlist changes',
                },
                {
                    position: 'top-right',
                },
            );
        } catch (err) {
            console.error(err);
        }
    };

    const customClickHandlers = {
        shareLink: handleShareClick,
        edit: handleEditClick,
        delete: handleDeleteClick,
    };

    return (
        <Menu as={MenuWrapper}>
            <Menu.Button
                as={IconButton}
                size="sm"
                IconLeft={FiSettings}
                IconRight={FiChevronDown}
            >
                Settings
            </Menu.Button>
            <Menu.Items as={MenuItems}>
                {Object.entries(menuItems).map(([key, Component]) => (
                    <Menu.Item key={key}>
                        {({ active, disabled }) => (
                            <Component
                                {...props}
                                disabled={disabled}
                                className={active ? 'active' : ''}
                                handleMenuClick={customClickHandlers[key]}
                                key={key}
                            />
                        )}
                    </Menu.Item>
                ))}
            </Menu.Items>
            <ConfirmDeleteModal
                isOpen={showDeleteModal}
                onCancel={handleCancelDelete}
                onConfirm={handleConfirmDelete}
            />
            <EditWatchlist
                isOpen={showEditModal}
                onCancel={handleCancelEdit}
                onUpdate={handleConfirmEdit}
                onDelete={() => {
                    handleCancelEdit();
                    handleDeleteClick();
                }}
                watchlist={props.watchlist}
            />
            <PublishWatchlist
                isOpen={showShareModal}
                onClose={handleCancelShare}
                watchlistId={props.watchlistId}
            />
        </Menu>
    );
}

export default WatchlistMenu;
